import React, { useState } from 'react'
import moment from 'moment'
import pluralize from 'pluralize'
import { useSelector } from 'react-redux'
import { Switch, Route, Link, useHistory, useParams } from 'react-router-dom'
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import { Drawer, message, DatePicker, Dropdown, Menu, Typography } from 'antd'

import { AiOutlineDown } from 'react-icons/ai'

import { useToggle, useListData, usePet, timeDiff, stringifyDate } from '../../modules'

import images from '../../images'

import Receive from '../resusable/receive'
import Modal from "../resusable/modal"
import Room from '../modals/room'

const RoomGroup = ({ onPerform }) => {
    let itemType = {}
    
    const [name, setName] = useState()
    const [selected, setSelected] = useState()
    const [category, setCategory] = useState()
    
    const [variants, setVariants] = useState([])
    const [categories, setCategories] = useState([])

    const [ingredients, setIngredients] = useState()
    const [imageUrl, setImageUrl] = useState(null)
    const [image, setImage] = useState(null)
    
    const [imgLoading, setImgLoading] = useState(false)
    const [variantsModal, toggleVariantsModal] = useToggle()
    const [visible, toggleVisible] = useToggle(true)
    
    const history = useHistory()
    const { id } = useParams()

    const [adding] = useState(id === 'new')

    const close = () => {
        toggleVisible()
        setTimeout(() => history.goBack(), 100)
    }

    const toggleAvailability = itm => {
        setSelected(itm)
        toggleItemAvailability()
    }

    const viewSaleItem = (itm, i) => {
        setSelected({
            item: itm,
            index: i
        })
        toggleVariantsModal()
    }

    const [{ loading, error }, getItem] = usePet('saleItem', { id }, { notify: true, manual: adding, callback: ({ data }) => {
        setName(data.name)
        setCategory({ label: data?.category, value: data?.category })
        setVariants(data.variants)
        setIngredients(data.ingredients)
    } })    

    const onComplete = ({}, notif, ops) => {
        onPerform()
        notif('Changes have been saved', ops('success'))
        setTimeout(adding ? close : getItem, 300)
    }

    const [{ loading: aLoading }, addGroup] = usePet('newSaleItemWithVariants', {
        name, 
        type: 'Recurring Item',
        category: category?.value, 
        price: 0,
        ref: null,
        variants
    }, { notify: true, hasFile: true, callback: onComplete, manual: true, load: { msg: 'Creating new group...' } })

    const [{ loading: eLoading }, editGroup] = usePet('editSaleItem', {
        id, 
        name, 
        category: category?.value, 
        ref: null,
        price: 0,
        ingredients: []
    }, { notify: true, hasFile: true, callback: onComplete, manual: true, load: { msg: 'Saving changes...' } })

    const [{ loading: catsLoading, error: catsError }] = usePet('accommodationCategories', null, { notify: true, callback: ({ data }) => setCategories(data) })
    
    const [, toggleItemAvailability] = usePet('toggleSaleItemAvailability', {
        id: selected?.item?._id
    }, { notify: true, callback: ({ data }, notif, ops) => {
        notif(`Item is now ${ data.unavailable ? 'unavailable' : 'available' }`, ops('success'))
        // fetchItems()
    }, manual: true })

    const modify = e => {
        switch (e.target.name) {
            case 'name':
                setName(e.target.value)
                break

            default:
                break
        }
    }

    const getBase64 = (img, callback) => {
        const reader = new FileReader()
        reader.addEventListener('load', () => callback(reader.result))
        reader.readAsDataURL(img)
    }

    const beforeUpload = file => {
        const isImage = file.type === 'image/jpeg' || file.type === 'image/png'
        if (!isImage) {
            message.warning('Please select an image file')
            return false
        }

        const sizeOK = file.size / 1024 / 1024 <= 1
        if (!sizeOK) {
            message.warning('Please select an image smaller than 1MB')
            return false
        }

        setImageUrl(null)
        setImage(file)
        setImgLoading(true)

        setTimeout(() => {
            setImageUrl(URL.createObjectURL(file))
            setImgLoading(false)
        }, 1000)

        return false
    }

    const handleChange = info => {
        if (info.file.status === 'uploading') {
            setImgLoading(true)
            return
        }

        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, url => {
                setImageUrl(url)
                setImgLoading(false)
            })
        }
    }

    const removeImage = () => {
        setImage(null)
        setImageUrl(null)
    }

    const deleteIngredient = i => {
        let temp = [...ingredients]
        temp = temp.filter((_, index) => i !== index)

        setIngredients(temp)
    }

    const addVariant = vrnt => {
        console.log(vrnt)
        let temp = [...variants, vrnt]

        setVariants(temp)
    }

    const editVariant = (vrnt, i) => {
        console.log(vrnt)
        let temp = [...variants]
        temp[i] = vrnt

        setVariants(temp)
    }

    const deleteVariant = i => {
        let temp = [...variants]
        temp = temp.filter((_, index) => i !== index)

        setVariants(temp)
    }

    return (
        <Drawer
            closable
            maskClosable
            visible={visible}
            onClose={close}
            footer={   
                <div className="w-full text-right">
                    <button disabled={ aLoading || eLoading } onClick={ adding ? addGroup : editGroup } className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">{ adding ? 'Create Group' : 'Save Changes' }</button>
                </div>
            }
            width="40%">
            <p className="font-extrabold text-3xl mb-0">{adding ? 'New Group' : name ?? 'Group Details'}</p>
            {
                variantsModal &&
                <Room
                    item={ selected?.item }
                    index={ selected?.index }
                    adding={ adding }
                    addNew={ addVariant }
                    edit={ editVariant }
                    visible={ variantsModal }
                    toggle={ toggleVariantsModal } />
            }
            <div className="flex flex-wrap -mx-3 pt-5 mb-3">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Name
                    </label>
                    <input
                        className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                        id="grid-name"
                        onChange={modify}
                        value={name}
                        type="text"
                        name="name"
                        placeholder="French Fries" />
                </div>
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Category
                    </label>
                    <Receive
                        loading={catsLoading}
                        error={catsError}>
                        <Creatable
                            value={category}
                            onCreateOption={val => {
                                let temp = [...categories]
                                temp.push(val)
                                setCategories(temp)
                                setCategory({ label: val, value: val })
                            }}
                            onChange={setCategory}
                            options={categories.map(cat => ({ label: cat, value: cat }))}
                            placeholder="Select Category" />
                    </Receive>
                </div>
            </div>
            <div className="font-bold mt-3">
                <div className="flex justify-between items-center">
                    <p className="font-bold my-3">Rooms</p>
                    <button onClick={ () => {
                        setSelected()
                        toggleVariantsModal()
                    }} className="btn hisani-btn-green text-white my-3">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">Add</span>
                    </button>
                </div>
                {
                    variants.length > 0 ?
                        <table className="table-auto w-full mb-3">
                            {/* Table header */}
                            <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                <tr>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">No</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Name</div>
                                    </th>
                                    <th className="p-2">
                                        <div className="font-semibold text-left">Price</div>
                                    </th>
                                    <th />
                                </tr>
                            </thead>
                            {/* Table body */}
                            <tbody className="text-sm font-medium divide-y divide-gray-100">
                                {
                                    variants.map((variant, key) =>
                                        <tr>
                                            <td className="p-2 text-left">{key + 1}</td>
                                            <td className="p-2 text-left">{variant.name}</td>
                                            <td className="p-2 text-left">Ksh. {variant.price}</td>
                                            <td className="p-2 text-left">
                                                <Dropdown
                                                    overlay={
                                                        <Menu>
                                                            <Menu.Item onClick={ () => viewSaleItem(variant, key) }>View</Menu.Item>
                                                            <Menu.Item onClick={ () => deleteVariant(key) }>Remove</Menu.Item>
                                                            {
                                                                !adding &&
                                                                <Menu.Item onClick={ () => viewSaleItem(variant) }>Make { variant.unavailable ? 'Available' : 'Unavailable' }</Menu.Item>
                                                            }
                                                        </Menu>
                                                    }>
                                                    <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                </Dropdown>
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        :
                        <div className="text-center my-4">
                            <h3>Please click above to add rooms</h3>
                        </div>
                }
            </div>
        </Drawer>
    )
}

export default RoomGroup